import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { FooterComponent } from 'app/layout/components/footer/footer.component';

@NgModule({
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule, MatToolbarModule, FuseSharedModule, FooterComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
